import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const ShoppingCartXIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
    <path d='M13 17h-7v-14h-2' />
    <path d='M6 5l14 1l-1 7h-13' />
    <path d='M22 22l-5 -5' />
    <path d='M17 22l5 -5' />
  </Icon>
);

export default ShoppingCartXIcon;
